<template>
  <v-container grid-list-md class="pa-0 ma-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs v-model="tab"
        flat color="primary" dark
        grow height="40"
        fixed-tabs @change="refreshData()">
        <v-tab v-for="(tabitem, n) in tabitems" :key="n" :href="`#tab-${n}`">
          {{ tabitem }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" @change="refreshData()">
        <v-tab-item v-for="(tabitem, n) in tabitems" :key="n" :value="`tab-${n}`">
          <v-layout v-if="tabitem === 'General'" row wrap>
            <!-- 1. view category-->
            <v-flex xs12>
              <v-card v-if="lCompAdr" flat class="pa-0">
                <v-card-title class="primary--text subheader pb-0">Complaints can be addressed to</v-card-title>
                <v-card-text class="pt-0">
                  <v-checkbox hide-details v-model="lCompAdr.is_hd_enabled" v-if="isHDPresent" label="Helpdesk Executive" @change="saveCompSet"></v-checkbox>
                  <v-checkbox hide-details v-model="lCompAdr.is_fm_enabled" v-if="isFMPresent" label="FM" @change="saveCompSet"></v-checkbox>
                  <v-checkbox hide-details v-model="lCompAdr.is_mc_enabled" label="Mgmt Committee" @change="saveCompSet"></v-checkbox>
                </v-card-text>
              </v-card>
              <v-divider></v-divider>
              <v-card flat v-if="lAction === 'view'">
                <v-card-title class="primary--text subheader pb-0">Services / Complaint categories</v-card-title>
                <v-card-text>
                  <v-flex xs12 sm9 md6>
                    <v-btn color="accent mb-0"
                    style="float: right" flat @click="prepareCreate">Add New</v-btn>
                    <v-data-table
                    :headers="catSet"
                    :items="catList"
                    hide-actions
                    disable-initial-sort
                    class="elevation-3">
                    <template slot="items" slot-scope="props">
                      <tr @click="prepareEdit(props.item)">
                        <td>{{ props.item.comp_cat }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout v-else row wrap>
          <v-flex xs12>
            <v-flex xs12 sm9 md6>
              <v-form @submit.prevent="saveChangesSla">
                <v-card flat>
                  <v-card-title class="primary--text subheader">
                    SLA
                  </v-card-title>
                  <v-card-text class="pt-0">
                    <v-layout row wrap>
                      <v-flex xs2 class="mt-1">
                        <span>Critical</span>
                      </v-flex>
                      <v-flex xs1>
                        <v-text-field class="mt-0 pt-0"
                        v-model="lCompSla.sla_critical"
                        hide-details
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 class="mt-1">
                        Hours
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs2 class="mt-1">
                        <span>Major</span>
                      </v-flex>
                      <v-flex xs1>
                        <v-text-field class="mt-0 pt-0"
                        v-model="lCompSla.sla_major"
                        hide-details
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 class="mt-1">
                        Hours
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs2 class="mt-1">
                        <span>Normal</span>
                      </v-flex>
                      <v-flex xs1>
                        <v-text-field class="mt-0 pt-0"
                        v-model="lCompSla.sla_normal"
                        hide-details
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 class="mt-1">
                        Hours
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent">save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
            <v-divider></v-divider>
            <v-flex xs12 sm9 md6>
              <span class="primary--text subheader">SLA Escalation</span>
              <v-form @submit.prevent="saveChangesSlaEsc">
                <v-card flat>
                  <v-card-title class="title pb-0">
                    Level 1
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lCompSlaEsc.l1_email_list"
                        label="Email list (comma seperated)"
                        hide-details
                        maxlength="200">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs7 sm5 class="mt-3 pb-0">
                      <v-switch
                      v-model="lCompSlaEsc.l1_sms_enabled"
                      label="Notify via SMS"
                      hide-details
                      ></v-switch>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm7>
                    <v-text-field
                    v-model="lCompSlaEsc.l1_phone_list"
                    :disabled="!lCompSlaEsc.l1_sms_enabled"
                    label="Phone number list"
                    hint="Eg:- 9741012345,0014266471234"
                    persistent-hint
                    maxlength="200"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-title class="title pb-0 mt-2">
                Level 2
              </v-card-title>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                    label="Email list (comma seperated)"
                    v-model="lCompSlaEsc.l2_email_list"
                    hide-details
                    maxlength="200">
                  </v-text-field>
                </v-flex>
                <v-flex xs7 sm5 class="mt-3 pb-0">
                  <v-switch
                  v-model="lCompSlaEsc.l2_sms_enabled"
                  label="Notify via SMS"
                  hide-details
                  ></v-switch>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm7>
                <v-text-field
                :disabled="!lCompSlaEsc.l2_sms_enabled"
                v-model="lCompSlaEsc.l2_phone_list"
                label="Phone number list"
                hint="Eg:- 9741012345,0014266471234"
                persistent-hint
                maxlength="200"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn type="submit" color="accent">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-flex>
</v-layout>
</v-tab-item>

<!-- 2. create / edit  category-->
<v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="lForm" @submit.prevent="saveChanges(lAction)">
        <v-card flat>
          <v-flex xs12 sm9 mx-auto>
            <v-card-title class="title pb-0">
              {{ handy.startWithUpper(lAction) }} category
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 class="mt-2">
                  <v-text-field
                  v-model="lCompCat.comp_cat"
                  label="Category"
                  :rules="[rules.required]"
                  hide-details
                  maxlength="25"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-spacer></v-spacer>
              <v-btn @click.stop="cancelChanges">Cancel</v-btn>
              <v-btn v-if="lAction === 'update'" @click="deleteCat(lCompCat)">delete</v-btn>
              <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="2000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-tabs-items>
</v-flex>
</v-layout>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      beingSaved: false,
      tab: 'tab-0',
      sbarMsg: '',
      lCompAdr: '',
      lCatList: '',
      lAction: '',
      lCompSla: '',
      lCompSlaEsc: '',
      handy: handy,
      rules: handy.rules,
      noSlaFound: false,
      noSlaEscFound: false,
      tabitems: ['General', 'SLA'],
      catSet: [
        { text: 'Service', value: 'comp_cat' }
      ],
      catList: [],
      isHDPresent: false,
      isFMPresent: false
    }
  },
  created () {
    this.loadCompSet()
    this.loadCatList()
  },
  mounted () {
    this.lAction = 'view'
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    refreshData () {
      if (this.tab === 'tab-0') {
        this.loadCompSet()
        this.loadCatList()
      } else {
        this.loadSlaHours()
        this.loadSlaEscLevels()
      }
    },
    loadCompSet () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      // is help desk available for community
      this.axios.get(config.API_URL + '/isHelpDeskAvailableForCommunity/', qry)
      .then(response => {
        if (response.data[0].total) {
          this.isHDPresent = true
        } else {
          this.isHDPresent = false
        }
      })
      // is fm available for community
      this.axios.get(config.API_URL + '/isFMAvailableForCommunity/', qry)
      .then(response => {
        if (response.data[0].total) {
          this.isFMPresent = true
        } else {
          this.isFMPresent = false
        }
      })
      // complaint settings
      this.axios.get(config.API_URL + '/getCompSetByCommId/', qry)
      .then(response => {
        this.lCompAdr = response.data[0]
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    saveCompSet () {
      if (this.lCompAdr.is_hd_enabled || this.lCompAdr.is_fm_enabled || this.lCompAdr.is_mc_enabled || this.lCompAdr.is_res_enabled) {
        this.axios.post(config.API_URL + '/category/settings', this.lCompAdr)
        .then(response => {
          // refresh the category address
          this.loadCompSet()
          this.$forceUpdate()
        })
        .catch(err => {
          this.msg(err.response.data)
        })
      } else {
        this.msg('Atleast one option needs to be enabled', 2)
        // refresh the category address
        this.loadCompSet()
      }
    },
    loadCatList () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getCompCatListByCommId/', qry)
      .then(response => {
        this.catList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    prepareCreate () {
      this.lCompCat = {
        comm_id: config.COMM_ID,
        comp_cat: ''
      }
      this.lAction = 'create'
    },
    prepareEdit (curCat) {
      this.lCompCat = Object.assign({}, curCat) // keep the original object safely before changes
      this.lAction = 'update'
    },
    cancelChanges () {
      if (this.action) { // in case come from different parent page, go there
        this.$router.go(-1)
      } else {
        this.lAction = 'view'
      }
    },
    saveChanges () {
      if (!this.$refs.lForm.validate()) {
        return
      }
      this.axios.post(config.API_URL + '/category/' + this.lAction, this.lCompCat)
      .then(response => {
        // refresh the Category list
        if (this.lAction === 'create') {
          this.lCompCat.comp_cat_id = response.data
          this.catList.push(this.lCompCat)
        } else {
          var idx = this.catList.findIndex(rec => rec.comp_cat_id === this.lCompCat.comp_cat_id)
          Object.assign(this.catList[idx], this.lCompCat)
        }
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    deleteCat (curCat) {
      if (!confirm('Sure, you want to delete the Category "' + curCat.comp_cat + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/category/delete', curCat)
      .then(response => {
        // refresh the list
        var idx = this.catList.findIndex(rec => rec.comp_cat_id === this.lCompCat.comp_cat_id)
        this.catList.splice(idx, 1)
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    loadSlaHours () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getSlaHoursByCommId/', qry)
      .then(response => {
        if (response.data.length === 0) {
          this.noSlaFound = true
          this.lCompSla = {
            sla_critical: '',
            sla_major: '',
            sla_normal: '',
            comm_id: config.COMM_ID
          }
        } else {
          this.lCompSla = response.data[0]
          this.noSlaFound = false
        }
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    saveChangesSla () {
      var action = this.noSlaFound ? 'create-sla' : 'update-sla'
      this.axios.post(config.API_URL + '/sla/' + action, this.lCompSla)
      .then(response => {
        if (action === 'create-sla') {
          this.noSlaFound = false
        }
        this.msg('Saved successfully', 1)
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadSlaEscLevels () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getSlaEscLevelsByCommId/', qry)
      .then(response => {
        if (response.data.length === 0) {
          this.noSlaEscFound = true
          this.lCompSlaEsc = {
            l1_phone_list: '',
            l1_sms_enabled: false,
            l1_email_list: '',
            l2_phone_list: '',
            l2_sms_enabled: false,
            l2_email_list: '',
            comm_id: config.COMM_ID
          }
        } else {
          this.lCompSlaEsc = response.data[0]
          this.noSlaEscFound = false
        }
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    saveChangesSlaEsc () {
      var action = this.noSlaEscFound ? 'create-sla-esc' : 'update-sla-esc'
      this.axios.post(config.API_URL + '/sla/' + action, this.lCompSlaEsc)
      .then(response => {
        if (action === 'create-sla-esc') {
          this.noSlaEscFound = false
        }
        this.msg('Saved successfully', 1)
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Compset.vue?0b7833ec